module.exports = __webpack_public_path__ + "img/card-end-term-hover.c36ab758.svg";